import React from "react";
import ReactDOM from "react-dom/client";
import { ConfigProvider } from "antd";
import locale from "@aligov/global-locale";
import zhCN from "antd/locale/zh_CN";
import enUS from "antd/locale/en_US";
import th_TH from "antd/locale/th_TH";

import App from "./App";
import "./i18n/config";
// import { useTranslation } from "react-i18next";

/**
 * axios全局配置
 * */
import "./axios.config";

const antdLocaleMap = {
  "zh-CN": zhCN,
  "en-US": enUS,
  "th-TH": th_TH,
};

const AppWithLocale = () => {
  const { lang } = locale.getLocale();
  const localelng = antdLocaleMap[lang] || enUS;

  return (
    <ConfigProvider locale={localelng}>
      <App />
    </ConfigProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("owtb-root"));

root.render(<AppWithLocale />);
